import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-view-status',
  templateUrl: './view-status.component.html',
  styleUrl: './view-status.component.scss',
})
export class ViewStatusComponent {
  @Input() public currentStatus = 0;
}
